import $ from "jquery";

var process_loader_spinner = 'fa fa-spinner';

const reservationForm = () => {
  const el = {
    main: ".confirm-reservation",
  };

  const init = () => {
    if (!$(el.main).length) return;
    handlerClick();
  };

  const handlerClick = () => {
    $(document).on('click', el.main, function(e) {
      e.preventDefault(); 
      var $this = $(this);
      var reservation_id = $this.data('reservation_id');

      // Make the AJAX call ourselves
      $.ajax({
        type: 'post',
        // eslint-disable-next-line
        url: parameters.url_admin_ajax,
        dataType: 'json',
        data: {
          'action': 'homey_confirm_reservation',
          'reservation_id': reservation_id
        },
        beforeSend: function() {
          $this.children('i').remove();
          $this.prepend('<i class=" '+process_loader_spinner+'"></i>');
        },
        success: function(data) {
          if (data.success) {
            $.ajax({
              // eslint-disable-next-line
              url: parameters.url_admin_ajax,
              type: 'POST',
              data: {
                action: 'homey_run_ical_sync_on_confirm',
                reservation_id: reservation_id
              },
              success: function() {
                $this.remove();
              },
              error: function() {
                $this.remove();
              }
            });
          } else {
            $this.prop('disabled', true).addClass('disabled').css('pointer-events', 'none');

            setTimeout(function() {
              window.location.reload();
            }, 3000);
          }
        },
        error: function() {
        },
        complete: function() {
          $this.children('i').removeClass(process_loader_spinner);
        }
      });
    });
  };

  init();
};

try {
  reservationForm();
} catch(error) {
  console.error("Confirm Reservation : ", error);
}
